import type { FC } from "react";

import type { Variants } from "@/src/common/links/useSvgStyle";
import { useSvgVariant } from "@/src/common/links/useSvgStyle";
import type { PropsWithStyleX } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
    icon: {
        height: "21px",
        width: "30px",
    },
});

export const EmailIcon: FC<PropsWithStyleX & { variant: Variants }> = ({ styleX, variant }) => {
    const { fill } = useSvgVariant(variant);

    return (
        <svg {...stylex.props(styles.icon, styleX)} viewBox="0 0 163.8 132">
            <path
                {...stylex.props(fill)}
                d="M146.3 1.8H18.7C9.7 1.8 2.5 9.1 2.5 18v95.6c0 8.9 7.3 16.2 16.2 16.2h127.6c8.9 0 16.2-7.3 16.2-16.2V18c0-8.9-7.3-16.2-16.2-16.2zM82.5 71l-64-34.6V17.9l64 34.6 64-34.6v18.5L82.5 71z"
            />
        </svg>
    );
};
